import jssVariables from "../../../jss_setup";

export const navbar = {
  NavBar: {},
  burgerBtn: {
    color: "white",
    borderColor: "white",
  },
  item: {
    textTransform: "unset",
    fontSize: "large",
    fontWeight: "bold",
    color: "white",
    "&:hover": {
      color: "white",
      textDecoration: "none!important",
    },
    "&:focus": {
      color: "white",
      textDecoration: "none!important",
    },
    smallscreen: {
      color: "white",
      fontSize: "medium",
      "&:hover": {
        color: "white",
        textDecoration: "none!important",
      },
      "&:focus": {
        color: "white",
        textDecoration: "none!important",
      },
    },
  },
  menuItems: {
    gridGap: `calc(${jssVariables.normal_gap} * 3)`,
  },
};
